import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getLanguage = createAsyncThunk(
  "language/getLanguage",
  async (_, { rejectWithValue }) => {
    try {
        const response = await api.get("/languages");
        const data = response.data.map(row => ({ label: row.short_name, value:row.id }));
        return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { status: "error", message: "Failed to get language." }
      );
    }
  }
);

const languageSlice = createSlice({
  name: "language",
  initialState: {
    languages: [],
    selected: null,
    status: "idle",
    loading: false,
  },
  reducers: {
    setSelectedLanguage(state, action) {
      state.selected = action.payload;
    },
    unsetSelectedLanguage(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.status  = "idle";
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getLanguage.pending, (state, action) => {
      state.loading = true;
    })
    .addCase(getLanguage.fulfilled, (state, action) => {
      state.languages = action.payload;
      state.loading = false;
    })
    .addCase(getLanguage.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setSelectedLanguage, unsetSelectedLanguage, resetStatus } = languageSlice.actions;
export default languageSlice.reducer;
